export default {
  generalInfo: 'General info',
  transactions: 'Transactions',
  openOrders: 'Open orders',
  assets: 'Assets',
};
